import {createStore} from "vuex";
import _ from "lodash";
import axios from "axios";

const store = createStore({
  state: {
    votingEnabled:        false,
    speedDatingActive:    false,
    speedDatingLastUser:  null,
    speedDatingCurrentRequest: null,
    speedDatingCurrentChat:    null,
    notifications:        [],
    onlineStatuses:       {},
    chats:                [],
    chatSideBarVisible:   false,
    openChats:            {},
    openChat:             null,
    contacts:             null,
    user:                 null,
    eventData:            null,
    favEventItems:        [],
    votes:                [],
    eventItems:           {},
    exhibitors:           [],
    viewedPosters:        [],
    program:              {},
    messagePagination:    {},
    loadingIndicators:    {},
    eventParticipants:    [],
    forumChannels:        [],
    forumThreads:         {},
    zoomMeetings:         [],
    liveStreams:          [],
    videoChatRooms:       [],
    presentUsers:         [],
    receivePresenceUpdates: false,
    currentVideoChatRoom: null,
  },
  getters: {
    favEventItemsObjects: state =>
      state.eventItems
        .filter(item => state.favEventItems.includes(item.id))
        .sort((a, b) => a.timestamp - b.timestamp),
    chatUnreadCount: state => {
      const unread = {};
      state.chats.forEach(chat => {
        unread[chat.id] = chat.messages.filter(
          m => m?.id && m.is_seen != 1 && m.is_seen !== true
        ).length;
      });
      return unread;
    },
    posterRooms: state => {
      if (!state.program?.sessions) return {};
      return _.sortBy(
        _.filter(state.program.sessions, { virtual_poster_room: true }),
        'shortRecordName'
      );
    },
  },
  mutations: {
    setZoomMeetings(state, ch) {
      state.zoomMeetings = ch.zoomMeetings;
      state.liveStreams  = ch.liveStreams;
    },
    removePresenceUser(state, user) {
      const idx = state.presentUsers.findIndex(u => u.id === user.id);
      if (idx !== -1) state.presentUsers.splice(idx, 1);
    },
    addPresenceUser(state, user) {
      state.presentUsers.push(user);
    },
    setStartRoomsOfPresenceUsers(state, channels) {
      Object.entries(channels).forEach(([room, userIds]) => {
        userIds.forEach(uid => {
          const idx = state.presentUsers.findIndex(u => u.id === uid);
          if (idx !== -1) state.presentUsers[idx].room = room;
        });
      });
    },
    setForumChannels(state, c) {
      state.forumChannels = c;
    },
    setEventParticipants(state, p) {
      state.eventParticipants = p;
    },
    setProgram(state, program) {
      state.program = program;
    },
    setVideoChatRooms(state, rooms) {
      state.videoChatRooms = rooms;
    },
    setOnlineStatuses(state, statuses) {
      state.onlineStatuses = statuses;
    },
    setAllMessagesRead(state, chatId) {
      const idx = state.chats.findIndex(c => c.id == chatId);
      if (idx === -1) return;
      let found = false;
      state.chats[idx].messages.forEach(msg => {
        if (msg.is_seen != 1 && msg.is_seen !== true) {
          msg.is_seen = 1;
          found = true;
        }
      });
      if (found) {
        axios.post(`/api/chat/markAsRead/${chatId}`, {}).catch(() => {});
      }
    },
    setMessagePagination(state, { chatId, data }) {
      Vue.set(state.messagePagination, chatId, data);
    },
    setLoadingIndicator(state, { chatId, data }) {
      Vue.set(state.loadingIndicators, chatId, data);
    },
    setExhibitors(state, exhibitors) {
      state.exhibitors = exhibitors;
    },
    setEventItems(state, items) {
      state.eventItems = items;
    },
    openChat(state, { id }) {
      state.openChat = id ?? null;
    },
    closeChat(state) {
      state.openChat = null;
    },
    setChats(state, chats) {
      chats.forEach(c => this.commit('addChat', c));
    },
    mergeChats(state, chats) {
      state.chats = _.merge(state.chats, chats);
    },
    addChatMessage(state, message) {
      message.message_id ??= message.id;
      const open = state.openChat;
      if (open === message.conversation_id) message.is_seen = 1;
      const chat = state.chats.find(c => c.id == message.conversation_id);
      if (!chat) {
        window.chatBus.$emit('forceGetChats');
        return;
      }
      const idx = chat.messages.findIndex(m => m.message_id == message.message_id);
      if (idx === -1) chat.messages.push(message);
      chat.messages.sort((a, b) => a.message_id - b.message_id);
      window.chatBus.$emit(`chat-delete-typing-${message.conversation_id}`, message);
    },
    addChat(state, chat) {
      const idx = state.chats.findIndex(c => c.id == chat.id);
      if (idx !== -1) {
        chat.messages = state.chats[idx].messages;
        state.chats[idx] = chat;
      } else {
        chat.messages ??= [];
        state.chats.push(chat);
      }
    },
    addNotification(state, notification) {
      const idx = state.notifications.findIndex(n => n.id == notification.id);
      if (idx !== -1) state.notifications.splice(idx, 1, notification);
      else state.notifications.unshift(notification);
    },
    markNotificationAsRead(state, notif) {
      const id = notif.id ?? notif;
      const idx = state.notifications.findIndex(n => n.id == id);
      if (idx !== -1) {
        state.notifications[idx].read_at    = Date.now();
        state.notifications[idx].created_at = notif.created_at;
      }
    },
    markAllNotificationsAsRead(state) {
      state.notifications = [];
    },
    setNotifications(state, notifs) {
      state.notifications = notifs;
    },
    setFavs(state, favs) {
      state.favEventItems = favs;
    },
    setVotes(state, votes) {
      state.votes = votes;
    },
    setViewedPosters(state, viewed) {
      state.viewedPosters = viewed;
    },
    removeFav(state, fav) {
      state.favEventItems = state.favEventItems.filter(id => id !== fav);
    },
    removeVote(state, vote) {
      state.votes = state.votes.filter(id => id !== vote);
    },
    addFav(state, fav) {
      if (!state.favEventItems.includes(fav)) state.favEventItems.push(fav);
    },
    addVote(state, vote) {
      if (!state.votes.includes(vote)) state.votes.push(vote);
    },
    setContacts(state, contacts) {
      state.contacts = contacts;
    },
    setUser(state, user) {
      state.user = user;
    },
    setEventData(state, data) {
      state.eventData = data;
    }
  }
});

export default store
